/**
 * Formatter for Random Gift Picker
 */

window.randomPrize = (function ($, generic) {
  // The return API
  var api = {};
  // Listener for the game ready event
  var _gameReady = $.Deferred();
  var analytics = function analytics(data) {
    if ('track' in window.site && 'evtLink' in window.site.track) {
      window.site.track.evtLink(data);
    }
  };
  // All the information about the offer is stored in this object
  var _offers = {
    offerArray: [],
    winningOffer: false,
    winningProduct: false,
    winningCategory: false,
    winningSku: false,
    offerProbability: {},
    offersProducts: {},
    availableOffers: {}
  };
  var _filters = {
    skuFilter: ['INVENTORY_STATUS', 'SKU_ID', 'PRODUCT_CODE'],
    productFilter: ['IMAGE_L'],
    categoryFilter: [],
    offerFilter: []
  };
  var _options = {
    continuePlayOnceWon: true, // allow the game to continue once the user has one
    stopGameUntilNextDayOnceWon: true, // stop the game until next day once offer added to bag
    stopGameFor24HoursOnceWon: false, // stop the game for 24h once offer added to bag
    useProductImages: true, // use product images if they are available
    showUnavailableOnOfferApplied: false
  };
  var _nodes = {
    gameFormatter: $('.js-game-formatter'),
    offerCodes: $('.js-offer-codes').val(),
    winChance: parseInt($('.js-win-chance').val()) || 50,
    numberOfTries: parseInt($('.js-no-of-tries').val()) || 3,
    customImagePath: $('.js-custom-image-path').val() || '',
    alwaysUseCustomImagePath: $('.js-always-use-custom-image-path').val() || false,
    setSingleOffer: $('.js-set-single-offer').val() || false
  };
  var _classNames = {
    win: 'game-formatter--won',
    lose: 'game-formatter--lost',
    error: 'game-formatter--error',
    maxTries: 'game-formatter--max-tries',
    noMoreTriesToday: 'game-formatter--no-more-tries-today',
    ended: 'game-formatter--ended',
    loading: 'game-formatter--loading'
  };
  var _cartResult = {};
  var _prizeData = {};
  var _activeOffer = false;
  var _setCookieExpiry = function (deleteCookie) {
    var date = new Date();

    if (deleteCookie) {
      date.setTime(date.getTime() - (24 * 60 * 60 + 1) * 1000);
    } else {
      if (!api.isCookieNextDay) {
        date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
      } else {
        date.setHours(24, 0, 0, 0);
      }
    }

    return date.toGMTString();
  };
  var _getProduct = function (offer_code) {
    if (_offers.offersProducts.skus && _offers.offersProducts.skus[offer_code] && _offers.offersProducts.skus[offer_code].length) {
      return _offers.offersProducts.products[_offers.offersProducts.skus[offer_code][0].PRODUCT_ID];
    }

    return false;
  };
  /* eslint-disable complexity */
  var _setOfferImage = function (product, image, imageSize) {
    var setImageSize = {
      large: 'IMAGE_L',
      medium: 'IMAGE_M',
      small: 'IMAGE_S'
    };
    var getImage = setImageSize.large;

    if (imageSize === 'medium') {
      getImage = setImageSize.medium;
    }

    if (imageSize === 'small') {
      getImage = setImageSize.small;
    }

    if (product && _nodes.alwaysUseCustomImagePath) {
      image = product[getImage][0].split('/').pop().replace('jpg', 'png');
    }

    if (image.indexOf(_nodes.customImagePath) === -1) {
      image = _nodes.customImagePath + image;
    }

    if (product && !_nodes.alwaysUseCustomImagePath) {
      return product[getImage][0];
    } else {
      return image;
    }
  };
  /* eslint-enable complexity */
  /**
   * Check the probability of the offers
   *
   * @param {object} offers - An array of offers, that should have a probability property
   * @param {number} totalProbability - The total probabilty of all the items
   * @returns {object} - the result of the offers
   */
  var _checkProbability = function (offers, totalProbability) {
    if (!offers) {
      return;
    }

    // Set the default to 100
    totalProbability = totalProbability || 100;

    var returnObj = {
      offers: [],
      probabilities: {}
    };

    $.each(offers, function (key, value) {
      var offer_and_probability = value.split ? value.split(':') : value;
      var probability = _offers.availableOffers[value].probability || 100 / Object.keys(offers).length;

      // Returns Object as it's an [Array] Object from a string split
      if (offer_and_probability && typeof offer_and_probability === 'object') {
        // Checks that there are items in the object
        if (Object.keys(offer_and_probability).length > 1) {
          // The offer works
          returnObj.offers[key] = offer_and_probability[0];
          returnObj.probabilities[offer_and_probability[0]] = offer_and_probability[1];
        } else {
          // It's a single offer
          returnObj.offers[key] = offer_and_probability[0];
          returnObj.probabilities[offer_and_probability[0]] = (probability / totalProbability) * 100;
        }
      } else {
        // should never hit here as offers should always be an object [array]
        returnObj.offers[key] = key;
        // Add the probability default as a backup
        returnObj.probabilities[offer_and_probability[0]] = (probability / totalProbability) * 100;
      }
    });

    return returnObj;
  };
  /**
   * Checks the probability that each item will have
   *
   * @param {array} offers - the list of offers you want the probability from
   * @returns {number} total probility
   */
  var _checkTotalProbability = function (offers) {
    var totalProbability = 0;

    $.each(offers, function (key, value) {
      if (value === null) { // check offer exists
        delete offers[key]; // remove from object
      } else {
        // check all offers are active
        if (value.timing !== 'active') {
          delete offers[key]; // remove from object
        } else {
          value.probability = value.probability || 100 / Object.keys(offers).length;
          totalProbability += value.probability;
        }
      }
    });

    return totalProbability;
  };
  /**
   * Used to simply return a random number within a range
   *
   * @param {number} numberStart - the number to start on
   * @param {number} numberRange - the number to go upto
   * @returns {number} the random number generated
   */
  var _getRandomNumber = function (numberStart, numberRange) {
    return Math.floor((Math.random() * numberRange) + numberStart);
  };
  /*
   * Get played number
   */
  var _currentTry = function (isApplyOffer) {
    var getNumberOfTriesCookie = parseInt(api.getNumberOfTriesCookie());
    var getMaxNumberOfTries = parseInt(api.getMaxNumberOfTries());

    if (getNumberOfTriesCookie >= getMaxNumberOfTries) {
      return getMaxNumberOfTries;
    } else if (isApplyOffer) {
      return getNumberOfTriesCookie;
    }

    /*
    * We need to increment `getNumberOfTriesCookie` by 1 each time as we may get the value before `getNumberOfTriesCookie` is updated.
    */
    return getNumberOfTriesCookie + 1 || 1;
  };

  /**
   * Set all cookies up to be either next day (expires at 00:00) or 24 hour expiry
   */
  api.isCookieNextDay = false;

  /**
   * This is where we set the prize before we even start playing the game
   *
   * @param {array} offers - list of offers
   * @param {number} probability - the chance of winning
   * @returns {false} none
   */
  /* eslint-disable complexity */
  api.setPrize = function (offers, probability) {
    var random_num = _getRandomNumber(1, 100, true);
    var weight_sum = 0;

    // Reset the winning items
    _offers.winningSku = false;
    _offers.winningProduct = false;

    // first check if this offer is already applied

    for (var i = 0; i < offers.length; i++) {
      weight_sum += parseInt(probability[offers[i]]);
      weight_sum = +weight_sum;

      if (random_num <= weight_sum) {
        _offers.winningOffer = _offers.availableOffers[offers[i]];

        // once we have the offer we can now get the prize if it is a sku related product
        if (_offers.offersProducts && typeof _offers.offersProducts.skus[_offers.winningOffer.offer_code] === 'object') {
          // START: Breaks eslint complexity rule
          // if a product type offer we should always have a sku as the backend should always return this
          if (_offers.offersProducts.skus[_offers.winningOffer.offer_code] && _offers.offersProducts.skus[_offers.winningOffer.offer_code].length) {
            // backend should only return valid skus, ie shoppable but lets do a check just in case
            for (var n = 0; n < _offers.offersProducts.skus[_offers.winningOffer.offer_code].length; n++) {
              // Set the products
              _offers.winningSku = _offers.offersProducts.skus[_offers.winningOffer.offer_code][n];
              // Set to a new product
              _offers.winningProduct = _offers.offersProducts.products[_offers.winningSku.PRODUCT_ID];
              // Check the product is in stock
              if (api.checkInventoryStatus() === 1 || api.checkInventoryStatus() === 6) {
                break;
              } else {
                _offers.winningSku = false;
                _offers.winningProduct = false;
              }
            }

            if (!_offers.winningSku && !_offers.winningProduct) {
              api.setPrize(_offers.offerArray, _offers.offerProbability);
            }
          }
          // END: Breaks eslint complexity rule
        }
        break;
      }
    }
  };
  /* eslint-enable complexity */

  api.setNewPrize = function (playAgain) {
    var currentTry = _currentTry();

    if (playAgain) {
      analytics({
        event_name: 'siteGame_playAgain',
        event_category: 'Site Game',
        event_action: 'Play Again',
        event_label: currentTry
      });
    } else {
      analytics({
        event_name: 'siteGame_play',
        event_category: 'Site Game',
        event_action: 'Play',
        event_label: currentTry
      });
    }

    api.setPrize(_offers.offerArray, _offers.offerProbability);
  };

  api.set24HourCookie = function () {
    api.isCookieNextDay = false;

    document.cookie = 'twenty_four=1;expires=' + _setCookieExpiry() + ';';
  };

  api.setNumberOfTriesCookie = function () {
    if (!api.getNumberOfTriesCookie()) {
      document.cookie = 'game_tries=1;expires=' + _setCookieExpiry() + ';';
    } else {
      var cookieCalc = parseInt(api.getNumberOfTriesCookie()) + 1;

      document.cookie = 'game_tries = ' + cookieCalc + ';expires=' + _setCookieExpiry() + ';';
    }
  };

  api.setWinningOfferCookie = function (offer_code) {
    document.cookie = 'winning_offer=' + offer_code + ';expires=' + _setCookieExpiry() + ';';
  };

  api.get24HourCookie = function () {
    return api.getCookie('twenty_four');
  };

  /**
   * A helper class for adding a Cookie to the users browser
   *
   * @param {string} name - the name of the cookie you want to add
   * @return {false} none
   */
  api.getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  };

  /*
   * Get winning offer cookie
   */
  api.getWinningOfferCookie = function () {
    var winning_offer = api.getCookie('winning_offer');

    return winning_offer ? winning_offer : '';
  };

  /*
   * Get next day cookie
   */
  api.getNextDayCookie = function () {
    return api.getCookie('game_next_day') ? 1 : 0;
  };

  /*
   * Set next day cookie
   */
  api.setNextDayCookie = function () {
    api.isCookieNextDay = true;
    document.cookie = 'game_next_day=1;expires=' + _setCookieExpiry() + ';';
  };

  /**
   * Get number of tries cookie
   *
   * @returns {bool} - result of the Game Tries Cookie
   */
  api.getNumberOfTriesCookie = function () {
    return api.getCookie('game_tries');
  };

  /**
   * Get the number of tries left
   *
   * @returns {number} - number of tries
   */
  api.getNumberOfTries = function () {
    return api.getNumberOfTriesCookie() || _nodes.numberOfTries;
  };

  /**
   * Get the number of tries left
   *
   * @returns {number} - number of tries
   */
  api.getMaxNumberOfTries = function () {
    return _nodes.numberOfTries;
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {object} - a copy of the _prizeData object
   */
  api.getPrize = function () {
    // do we have a sku as a prize?
    if (typeof _offers.winningSku === 'object') {
      $.each(_filters.skuFilter, function (key, value) {
        _prizeData[value] = _offers.winningSku[value] ? _offers.winningSku[value] : '';
      });
      $.each(_filters.productFilter, function (key, value) {
        _prizeData[value] = _offers.winningProduct[value] ? _offers.winningProduct[value] : '';
      });
      $.each(_filters.categoryFilter, function (key, value) {
        _prizeData[value] = _offers.winningCategory[value] ? _offers.winningCategory[value] : '';
      });
      $.each(_filters.offerFilter, function (key, value) {
        _prizeData[value] = _offers.winningOffer[value] ? _offers.winningOffer[value] : '';
      });
    }

    return _prizeData;
  };

  /**
   * Get the chance of winning per round
   *
   * @returns {number} win_change reference
   */
  api.getWinChance = function () {
    return _nodes.winChance;
  };

  /**
   * Hides any popup box that is currently showing
   *
   * @returns {false} none
   */
  api.hidePopup = function () {
    _nodes.gameFormatter.removeClass(_classNames.win + ' ' + _classNames.lose + ' ' + _classNames.error + ' ' + _classNames.noMoreTriesToday + ' ' + _classNames.ended);
  };

  api.scrollToTop = function (offsetHeight) {
    offsetHeight = offsetHeight || $('.js-sticky-header .js-site-header-sticky').parent().height() || 0;
    var offset = _nodes.gameFormatter.offset().top - offsetHeight;

    $('html, body').animate({
      scrollTop: offset
    }, 450);
  };

  /**
   * Show the unavailable message
   *
   * @returns {false} none
   */
  api.getUnavailableMessage = function () {
    api.hidePopup();

    _nodes.gameFormatter.addClass(_classNames.noMoreTriesToday);

    api.scrollToTop();
  };

  /**
   * Show the Error message
   *
   * @param {string} errorMsg - the error message to show with the Error Box
   * @returns {false} none
   */
  api.getErrorMessage = function () {
    api.hidePopup();

    _nodes.gameFormatter.addClass(_classNames.error);

    api.scrollToTop();
  };

  api.gameEnded = function () {
    api.hidePopup();

    _nodes.gameFormatter.addClass(_classNames.ended);

    api.scrollToTop();
  };

  api.setWinState = function () {
    _nodes.gameFormatter.addClass(_classNames.win);
  };

  api.setLoseState = function () {
    _nodes.gameFormatter.addClass(_classNames.lose);
  };

  api.setMaxTriesState = function () {
    _nodes.gameFormatter.addClass(_classNames.maxTries);
  };

  /**
   * Returns a JSON Object with the Winning Information
   *
   * @returns {Object} winInfo - Winning information in a Object Form
   */
  /* eslint-disable complexity */
  api.getWinningOffer = function () {
    var offerCode = typeof _offers.winningOffer === 'object' ? _offers.winningOffer.offer_code : false;
    var offerCodeCookie = api.getWinningOfferCookie();

    if (offerCodeCookie && offerCodeCookie !== 'none') {
      offerCode = offerCodeCookie;
      _offers.winningOffer = _offers.availableOffers[offerCode];
    }
    // There is no offer to return to the user
    if (!_offers.winningOffer) {
      return {
        valid: false,
        error: 'no_offer'
      };
    }

    analytics({
      event_name: 'siteGame_win',
      event_category: 'Site Game',
      event_action: 'Win',
      event_label: _currentTry(),
      product_list: ['/siteGame'],
      product_impression_list: ['/siteGame'],
      product_impression_position: '1',
      product_impression_id: [_offers.winningOffer.offer_code],
      product_position: '1',
      product_id: [_offers.winningOffer.offer_code]
    });

    // Does the offer have a SKU?
    // If it does lets grab a product
    // Pick the first match for the product
    var winningProduct = _offers.winningProduct;
    var winningConfirmMessage = String(_offers.winningOffer.confirm_message).replace('::skuname::', winningProduct ? winningProduct.PROD_RGN_NAME : '');
    var description = String(_offers.winningOffer.description).replace('::skuname::', winningProduct ? winningProduct.PROD_RGN_NAME : '');

    return {
      // Is the offer Valid or not
      valid: _offers.winningOffer !== false,
      // Add the winning offer object
      winningOffer: _offers.winningOffer,
      // Add the winning sku object
      winningSku: _offers.winningSku,
      // Add the winning product object
      winningProduct: _offers.winningProduct,
      // Winning title,
      title: '',
      // Description for the win message
      description: description,
      // Confirm message
      confirmMessage: winningConfirmMessage,
      // The image assosiated with this winning offer
      image: _setOfferImage(winningProduct, _offers.winningOffer.offer_code + '.png'),
      // Does the user have the ability to play again
      playAgain: parseInt(api.getNumberOfTriesCookie()) < _nodes.numberOfTries
    };
  };
  /* eslint-enable complexity */

  /**
   * Validate that the game is ready to be played
   *
   * @return {bool} - is the Game ready
   */
  api.isGameValidforPlay = function () {
    var areTriesLeft = api.getNumberOfTriesCookie() <= _nodes.numberOfTries;
    var haveTheyWon = _options.continuePlayOnceWon || (!_options.continuePlayOnceWon && !api.has_won);
    var isGameActive = !_options.stopGameFor24HoursOnceWon; // Check we don't have this option enabled

    return areTriesLeft && haveTheyWon && isGameActive;
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {bool} iShoppable reference
   */
  api.isShoppable = function () {
    return _offers.winningSku.isShoppable;
  };

  /**
   * We can check to see if an other has been applied
   *
   * @param {array} offers - Array of offer codes
   * @returns {bool} iShoppable reference
   */
  api.isOfferApplied = function (offers) {
    for (var i = 0; i < offers.length; i++) {
      return _offers.availableOffers[_activeOffer && _offers.availableOffers[_activeOffer] ? _activeOffer : offers[i]];
    }
  };

  /**
   * Detects if the user has already played the game or not
   *
   * @returns {bool} true if played
   */
  api.isAlreadyPlayed = function () {
    var currentOffer = api.getWinningOffer() || {
      'valid': false
    };

    return currentOffer.valid && api.getWinningOfferCookie() && api.getNextDayCookie() ? true : false;
  };

  /*
   * Delete winning offer cookie
   */
  api.deleteWinningOfferCookie = function () {
    document.cookie = 'winning_offer=;expires=' + _setCookieExpiry(true) + ';';
  };

  /*
   * Delete next day cookie
   */
  api.deleteNextDayCookie = function () {
    api.isCookieNextDay = true;

    document.cookie = 'game_next_day=1;expires=' + _setCookieExpiry(true) + ';';
  };

  /*
   * Delete 24h cookie
   */
  api.delete24HourCookie = function () {
    api.isCookieNextDay = false;

    document.cookie = 'twenty_four=1;expires=' + _setCookieExpiry(true) + ';';
  };

  /**
   * This is where we get all the offers, set the probability (if set in Drupal) and set the winning price
   *
   * @return {false} none
   */
  api.parseOfferAndProbability = function () {
    _offers.offerArray = _nodes.offerCodes.split(',');

    var params = [
      {
        'offers': _offers.offerArray,
        'get_products': 1,
        'get_transaction': 1
      }
    ];
    var setOffers = function (responseValues) {
      if (Object.keys(responseValues.offers || {}).length) {
        _offers.availableOffers = responseValues.offers;
      } else {
        _offers.availableOffers = false;
      }

      if (Object.keys(responseValues.offersProducts || {}).length) {
        _offers.offersProducts = responseValues.offersProducts;
      } else {
        _offers.offersProducts = false;
      }
    };
    var setCartResults = function (responseValues) {
      if (Object.keys(responseValues.transaction || {}).length) {
        _cartResult = responseValues.transaction;
      } else {
        _cartResult = false;
      }
    };

    generic.jsonrpc.fetch({
      method: 'offers.getOffersRpcData',
      params: params,
      onSuccess: function (response) {
        var responseValues = response.getValue();

        if (responseValues) {
          setCartResults(responseValues);

          setOffers(responseValues);

          // offer was already set
          if (_nodes.setSingleOffer && _cartResult && _cartResult.offerCodes) {
            _activeOffer = _cartResult.offerCodes[0];
          }
        }

        if (Object.keys(_offers.availableOffers).length > 0) {
          var probabilty = _checkProbability(_offers.offerArray, _checkTotalProbability(_offers.availableOffers));

          _offers.offerArray = probabilty.offers;
          _offers.offerProbability = probabilty.probabilities;

          api.isOffers = true;
        } else {
          api.isOffers = false;

          api.gameEnded();
        }

        _nodes.gameFormatter.removeClass(_classNames.loading);

        _gameReady.resolve();
      },
      onFailure: function () {
        _nodes.gameFormatter.removeClass(_classNames.loading);

        api.getErrorMessage();
      }
    });
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {string} - Inventory Status of the current Winning Sku
   */
  api.checkInventoryStatus = function () {
    return _offers.winningSku.INVENTORY_STATUS;
  };

  /**
   * User has the offer already in their cart
   *
   * @returns {boolean} true if the offer is in the cart
   */
  api.hasOfferInCart = function () {
    var winningOfferInfo = api.getWinningOffer();

    return winningOfferInfo.valid && $.inArray(winningOfferInfo.winningOffer.offer_code, _cartResult.offerCodes) >= 0;
  };

  api.getCurrentOffer = function (offer_code) {
    var product = _getProduct(offer_code);
    var offer = _offers.availableOffers[offer_code];

    if (product) {
      offer.description = product.PROD_RGN_NAME;
    }
    offer.image = _setOfferImage(product, offer.offer_code + '.png');

    return offer;
  };

  /**
   * Apply the current Winning Offer via the JSONRPC Call
   *
   * @param {function} onSuccess (optional) - An on Sucess Function
   * @param {function} onFail (optional) - An on Fail Function
   * @returns {bool} false
   */
  api.applyOffer = function (onSuccess, onFail) {
    var offer_code = _offers.winningOffer.offer_code;
    var currentTry = _currentTry(true);
    var offer_value;
    var offer_params;

    analytics({
      event_name: 'siteGame_productClick',
      event_category: 'Site Game',
      event_action: 'Product Click',
      enh_action: 'product_click',
      product_position: '1',
      product_list: ['/siteGame'],
      event_label: currentTry,
      product_id: [_offers.winningOffer.offer_code]
    });

    analytics({
      event_name: 'siteGame_productDetail',
      event_category: 'Site Game',
      event_action: 'Product Detail',
      enh_action: 'detail',
      event_label: currentTry,
      product_id: [_offers.winningOffer.offer_code]
    });

    analytics({
      event_name: 'siteGame_productAdd',
      event_category: 'Site Game',
      event_action: 'Add to Bag',
      enh_action: 'add',
      event_label: currentTry,
      product_id: [_offers.winningOffer.offer_code],
      product_quantity: [1]
    });

    if (_offers.winningProduct) {
      offer_value = _offers.winningProduct.product_ID;
      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            ChoiceOfSkus: {
              choices: [_offers.winningProduct.product_ID]
            }
          }
        }
      ];
    } else {
      offer_value = _offers.winningOffer.benefits[0].value;
      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            PercentDiscount: {
              class: offer_value
            }
          }
        }
      ];
    }

    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: offer_params,
      onSuccess: function (res) {
        if (typeof onSuccess === 'function') {
          onSuccess(res);
        }
      },
      onFailure: function (error) {
        if (typeof onFail === 'function') {
          onFail(error);
        } else {
          api.getErrorMessage();
        }
      }
    });
  };

  /* Return array of all offer codes set in the CMS */
  api.getAllOfferCodes = function () {
    return _offers.offerArray;
  };

  /* Return if user has won or not - call this per turn */
  api.getWinOrLose = function () {
    var winChance = api.getWinChance();
    var randomNumber = _getRandomNumber(1, 100);
    var getNumberOfTries = api.getNumberOfTriesCookie() || 0;
    var getMaxNumberOfTries = api.getMaxNumberOfTries();
    var numberOfTriesRemaining = getMaxNumberOfTries - getNumberOfTries;

    api.hidePopup();

    if (randomNumber > winChance || numberOfTriesRemaining === 1) { // always win on last turn
      return true;
    } else {
      return false;
    }
  };

  /**
   * Initialise the game, this needs to be called for the game to begin
   *
   * @param {function} onComplete (optional) - a function called when the init has completed
   * @return {bool} true
   */
  api.init = function (onComplete) {
    api.parseOfferAndProbability();

    $.when(_gameReady).then(function () {
      // setup an object to return to the onComplete
      var returnObj = {
        api: api,
        isValid: api.isGameValidforPlay(),
        numberOfTries: api.getNumberOfTries()
      };

      if (typeof onComplete === 'function') {
        onComplete(returnObj);
      }
    });

    return true;
  };

  // @return the API Object
  return api;
})(window.jQuery, window.generic || {});
